import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { Settings } from 'lucide-react';
import { Button } from '@/shared/components/ui/button';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/shared/components/ui/dialog';
import { useIsAdmin } from '@/shared/hooks/use-admin-validation';
import { KnowledgeSecurity } from './KnowledgeSecurity';
import { BRAIN_SETTINGS_OPEN, BRAIN_SETTINGS_PARAM } from '../utils/brainTabs';

/**
 * Configurações do Brain (AB#87121): a engrenagem ao lado do título no breadcrumb,
 * só para admin. Guarda o que vale para o Brain inteiro — hoje, limpá-lo (a antiga
 * aba Security). A abertura vive no `?settings=brain`, para o link continuar valendo.
 */
export function BrainSettingsButton() {
  const { t } = useTranslation();
  const { isAdmin } = useIsAdmin();
  const [searchParams, setSearchParams] = useSearchParams();
  const open = searchParams.get(BRAIN_SETTINGS_PARAM) === BRAIN_SETTINGS_OPEN;

  if (!isAdmin) return null;

  const setOpen = (next: boolean) => {
    setSearchParams(
      (params) => {
        if (next) params.set(BRAIN_SETTINGS_PARAM, BRAIN_SETTINGS_OPEN);
        else params.delete(BRAIN_SETTINGS_PARAM);
        return params;
      },
      { replace: true }
    );
  };

  return (
    <>
      <Button
        variant="ghost"
        size="icon"
        className="h-8 w-8 text-muted-foreground hover:text-foreground"
        onClick={() => setOpen(true)}
        aria-label={t('knowledge.brain.settings.open')}
        title={t('knowledge.brain.settings.open')}
      >
        <Settings className="h-4 w-4" />
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-3xl max-h-[85vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle>{t('knowledge.brain.settings.title')}</DialogTitle>
            <DialogDescription>{t('knowledge.brain.settings.description')}</DialogDescription>
          </DialogHeader>
          <KnowledgeSecurity />
        </DialogContent>
      </Dialog>
    </>
  );
}
